import { passThroughAxios } from './passThrough.axios'

export default {
  getAuditTrail(changeOrderId) {
    return passThroughAxios.get(`change-order/${changeOrderId}/audit-trail`)
  },
}
